class Menu {
  constructor() {
    this.headerEl = document.querySelector('header');
    this.menuOptWithChildEls = this.headerEl.querySelectorAll('.menu-desktop__option--has-children');
    this.subMenuEls = this.headerEl.querySelectorAll('.menu-desktop__submenu');
    this.menuHambEl = this.headerEl.querySelector('.menu-mobile__hamb');
    this.menuMobileEl = this.headerEl.querySelector('.menu-mobile');

    this.isSubmenuOpen = false;
    this.animationTime = 0;

    this.init();
  }

  /** INIT **/
  init() {
    //open submenu
    this.menuOptWithChildEls.forEach(el => {
      if(this._isTouchEnabled()) {
        el.addEventListener('touchstart', (e) => {
          e.stopPropagation();
          if(!el.querySelector('.menu-desktop__submenu').classList.contains('menu-desktop__submenu--active'))
            this.submenuOpen(el);
        });

        document.body.addEventListener('touchstart', () => {
          if(this.isSubmenuOpen)
            this.closeSubmenus();
        });
      }
      else {
        el.addEventListener('mouseenter', () => {
          this.submenuOpen(el);
        });
        //close submenu
        el.addEventListener('mouseleave', this.closeSubmenus.bind(this));
      }

    });

    this.menuHambEl.addEventListener('click', e => {
      document.documentElement.classList.toggle('menu-mobile--active');
      e.currentTarget.querySelector('span').innerHTML = e.currentTarget.querySelector('span').innerHTML === 'Menu' ? 'Close' : 'Menu';
    });

    //HIDE LOGO ON SCROLL IN LISTING PAGES
    const bodyTrigger = document.querySelector('.body-trigger');

    if(bodyTrigger) {
      const logoEl = document.querySelector('.header__logo');
      let logoShouldBeHidden = false;

      //Check if logo should be hidden
      const observer = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if(entry.boundingClientRect.y > 0) {
            if (entry.intersectionRatio > 0) {
              logoShouldBeHidden = true;
              logoEl.classList.add('header__logo--hidden');
            } else {
              logoShouldBeHidden = false;
              logoEl.classList.remove('header__logo--hidden');
            }
          }
        });
      }, {
        root: null,
        threshold: 0,
      });
      observer.observe(bodyTrigger);

      //Hide if on scroll shoulde be hidden
      document.addEventListener('scroll', (e) => {
        if(logoShouldBeHidden)
          logoEl.classList.add('header__logo--hidden');
      });

      //on inactivity time show logo
      const inactivityTime = function () {
        let t;
        document.onscroll = resetTimer;

        function resetTimer() {
          clearTimeout(t);

          t = setTimeout(() => {
            logoEl.classList.remove('header__logo--hidden');
          }, 1500); //1.5 seconds
        }
      };
      inactivityTime();
    }
  }

  submenuOpen(el) {
    //Se o submenu esta aberto
    // if(this.isSubmenuOpen) {
    //   this.closeSubmenus();
    //   setTimeout(() => {
    //     this.openSubmenu(el);
    //   }, this.animationTime);
    // }
    // else {
      this.openSubmenu(el);
    // }
  }

  /** CLOSE SUBEMENU **/
  closeSubmenus() {
    this.subMenuEls.forEach(el => {
      el.classList.remove('menu-desktop__submenu--active');
    });
    this.menuOptWithChildEls.forEach(el => {
      el.classList.remove('menu-desktop__option--submenu-active');
    });

    // setTimeout(() => {
      this.isSubmenuOpen = false;
    // }, this.animationTime);
  }

  /** OPEN SUBEMENU **/
  openSubmenu(el) {
    el.querySelector('.menu-desktop__submenu').classList.add('menu-desktop__submenu--active');

    if(el.classList.contains('menu-desktop__option--search'))
      el.querySelector('input').focus();

    this.isSubmenuOpen = true;
  }

  /** IS A TOUCH DEVICE **/
  _isTouchEnabled() {
    return ( 'ontouchstart' in window ) ||
           ( navigator.maxTouchPoints > 0 ) ||
           ( navigator.msMaxTouchPoints > 0 );
  }

  /*
  * DEBOUNCE
  var example = debounce(function() {
  }, 500);
  */
  _debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this,
        args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }
}

export default Menu;
